<template> 

  <div class="container pt-4 mb-5">

    <b-button variant="light" @click="$router.back()">
      <span class="material-symbols-outlined align-middle">chevron_left</span>
      Wróć
    </b-button>

    <div>
      
      <b-row align-v="center">

        <b-col lg="12">

          <div class="mt-4">

            <div class="mt-3">

              <label>Na jaki temat chcesz napisać bezpłatny raport:</label>

              <b-input-group>

                <b-form-input v-model="tematyka" size="lg" ref="tematyka" placeholder="np. dieta, dieta keto, donica ogrodowa, zabawka edukacyjna z drewna"></b-form-input>

              </b-input-group>

            </div>

            <div class="mt-3">

              <label>Opisz krótko twojego klienta docelowego:</label>

              <b-input-group>

                <b-form-input v-model="klient" size="lg" ref="klient" placeholder="np. mężczyzna w wieku 30-40 lat, który chce się pozbyć problemu łysienia"></b-form-input>

              </b-input-group>

            </div>

          </div>

        </b-col>

      </b-row>
  
      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">
        
        </b-col>

        <b-col lg="6">

        <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
          Generuj
        </b-button> 

        </b-col>

      </b-row>



      <div class="mt-2" >
  
        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje treść <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Wygenerowana treść</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" v-if="result" style="font-size: 1em;">
            
            <div class="mb-3 mt-3 p-3" style="border: 1px dashed #f3f3f3; font-size: 1em; line-height: 1.7em;">

              <div v-if="result2" v-html="result2" class="pb-3 mb-3" style="border-bottom: 1px solid #ddd;"></div>

              <span v-for="item in result" :key="item">

                <span style="cursor: pointer;" @click="getArticle(item)">{{ item }}</span><br/>

              </span>

            </div>

            <div class="text-primary pointer small mt-1 float-right" @click="copyResults">

              <span class="material-symbols-sharp align-middle">content_copy</span>
              Kopiuj do schowka

            </div>

          </blockquote>

        </b-card>
   
        <textarea ref="selectedText" style="display: none;" v-model="selectedText" v-on:focus="$event.target.select()"></textarea>   
        <textarea ref="finishContent" style="display: none;" v-model="finishContent" v-on:focus="$event.target.select()"></textarea>

      </div>
 
    </div>

  </div>

</template>

<script>

  export default {
    name: '',
    components: {
    },
    data() {
      return {
        isFinish: false,
        result: "",
        result2: "",
        selectedText: '',
        query: "",
        tematyka: "",
        klient: "",
        finishContent: '',
        selectedSchema: null
      }
    },
    methods: {

      getArticle: function (title) {

        if(!title) return false;

        this.$refs.generatePost.disabled = true

        this.isFinish = true

        this.finishContent = ""
        this.result2 = ""

        var query = "Napisz mi rozbudowany artykuł na bloga w którym odpowiadasz rzeczowo na pytanie " + title + ". Odpowiedz konkretnie i wyczerpująco, językiem eksperckim.";

        query = query + "Używaj znaczników HTML zamiast markdown. Dozwolone znaczniki: Pogrubienie czyli <B></B>, i nowa linia <br/> . Zamiast znaczników nagłówków Hx użyj po prostu pogrubienia.";


        var doneText = "";

        this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", { 'text': query, 'v': 'o1' }, { withCredentials: true, timeout: 3000000 }).then((response) => {

          let data = response.data

          if(data.redirectTo) { 

            top.location.href = data.redirectTo;

          }

          doneText = data.result;

          this.finishContent = doneText;

          this.result2 = doneText.replace(/(?:\r\n|\r|\n)/g, '<br/>');


          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowana treść"

        }).catch(function() {

          this.$refs.generatePost.disabled = false

        })


      },

      generateFinish: function() {

        if(!this.tematyka) return false;
        if(!this.klient) return false;

        this.$refs.generatePost.disabled = true

        this.isFinish = true

        this.finishContent = ""
        this.result = ""

        var query = "Wypisz mi 30 najczęstszych pytań w temacie " + this.tematyka + " potrzebuję tych pytań do napisania raportu nt. najczęstsze pytania i odpowiedzi w tematyce " + this.tematyka + ". Grupa docelową będą osoby " + this.klient + ".  Każdy tytuł umieść w nowej linii. Tytuł może zawierać tylko treść bez numeracji i bez myślników. NIE NUMERUJ WIERSZY, NIE DODAWAJ MYŚLNIKÓW.";

        var doneText = "";

        this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", { 'text': query, 'v': 'o1' }, { withCredentials: true, timeout: 3000000 }).then((response) => {
  
          let data = response.data
 
          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          doneText = data.result;

          this.finishContent = doneText;

          this.result = doneText.replace(/(?:\r\n|\r|\n)/g, '<br/>');

          this.result = this.result.split('<br/>');

          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowana treść"

        }).catch(function() {

          this.$refs.generatePost.disabled = false

         })
 
        
 
      },
 
      copyResults: function() {
 
        this.$refs.finishContent.style.display = "block";
        
        this.$refs.finishContent.focus();

        document.execCommand('copy');
         
        this.$refs.finishContent.style.display = "none"

        window.scrollTo(0, 0)

        this.$bvToast.toast('Treść została skopiowana do schowka', {
          title: 'Skopiowano',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })

      } 

    },
    computed: {
  
    },
    created() {

      this.$watch('finishContent', (value) => {

        var lines = value.split(/\r|\r\n|\n/);

        this.finishLinesCount = lines.length;

      })
 
    },

    mounted() {

      if (localStorage.bgai_tematyka) {
        this.tematyka = localStorage.bgai_tematyka;
      }

      if (localStorage.bgai_klient) {
        this.klient = localStorage.bgai_klient;
      }

    },
    watch: {

      tematyka(data) {
        localStorage.bgai_tematyka = data;
      },

      klient(data) {
        localStorage.bgai_klient = data;
      }

    }


  }
</script>

<style>

  .pointer { cursor: pointer; }
  .bold { font-weight: 600 !important; }
  code { color: #4e82f7 !important; }
</style>